import { Button } from '@/components/ui/button';
import { ArrowUpDown, CirclePlus } from 'lucide-react';
import { AccountAddDialog } from '../account-form/account-add-dialog';
import { AccountSortDialog } from '../account-form/account-sort-dialog';
import { BankImportDialog } from '@/components/bank-import/bank-import-dialog';

export function AccountsButton() {
  return (
    <>
      <div className="flex space-x-2  w-full">
        <AccountAddDialog>
          <Button size="sm" className="flex-grow" variant="outline">
            <CirclePlus className="mr-2 h-4 w-4" />
            <span>Add </span>
          </Button>
        </AccountAddDialog>
        <AccountSortDialog>
          <Button size="sm" className="flex-grow" variant="outline">
            <ArrowUpDown className="mr-2 h-4 w-4" />
            <span>Sort</span>
          </Button>
        </AccountSortDialog>
        <BankImportDialog />
      </div>
    </>
  );
}
